//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class AddGroupModel extends ModelBase {
      static readonly $typeName = 'AddGroupModel';
      public name: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/customer/models/AddGroupModel.ts